import { IGame } from "@/redux/games/types";

export function isGamePast(game: IGame): boolean {
  const now = new Date();
  
  try {
    const [hours, minutes] = game.endTime.split(':').map(Number);
    
    if (isNaN(hours) || isNaN(minutes)) {
      console.warn(`Failed to parse end time: ${game.endTime}`);
      return false;
    }
    
    let gameDate: Date;
    
    if (game.date.includes('-')) {
      gameDate = new Date(game.date);
      if (isNaN(gameDate.getTime())) {
        const [year, month, day] = game.date.split('-').map(Number);
        gameDate = new Date(year, month - 1, day, hours, minutes);
      } else {
        gameDate.setHours(hours, minutes, 0, 0);
      }
    } else if (game.date.includes('.')) {
      const [day, month, year] = game.date.split('.').map(Number);
      gameDate = new Date(year, month - 1, day, hours, minutes);
    } else {
      gameDate = new Date(`${game.date}T${game.endTime}:00`);
      
      if (isNaN(gameDate.getTime())) {
        gameDate = new Date(game.date);
        gameDate.setHours(hours, minutes, 0, 0);
      }
    }
    
    if (isNaN(gameDate.getTime())) {
      console.warn(`Failed to parse game date: ${game.date} ${game.endTime}`);
      return false;
    }
    
    // Скрываем за 30 минут до окончания (как в аренде кортов)
    gameDate.setMinutes(gameDate.getMinutes() - 30);
    return gameDate < now;
  } catch (error) {
    console.error(`Error checking if game is past:`, error);
    return false;
  }
}

export function filterPastGames(games: IGame[]): IGame[] {
  return games.filter((game) => !isGamePast(game));
}
